
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M12.21 35.51L1.62 58.52h45.85L24.55 8.72l-4.49 9.75"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M49.81 41.75l8.44 16.77H47.4M36.93 35.74l4.93-9.81 3.73 7.42"}}),_c('circle',{attrs:{"cx":"50.2","cy":"8.98","r":"7.5","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M7.21 35.12a5.59 5.59 0 112.2-10.72 8.38 8.38 0 118 10.72zM55.69 41.72a3.29 3.29 0 10-1.3-6.32 4.93 4.93 0 10-4.74 6.32z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    